import { getStepStatus, Paper, Step, Stepper, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import * as React from 'react'

import { InstalacaoHeader } from './InstalacaoHeader'

export enum InstalacaoStep {
  IDENTIFICAR,
  CADASTRAR,
  FINALIZAR,
}

export interface InstalacaoLayoutProps {
  step: InstalacaoStep
  children: React.ReactNode
}

export const InstalacaoLayout = (props: InstalacaoLayoutProps) => {
  const { step, children } = props

  return (
    <PageContent>
      <VFlow vSpacing={2}>
        <InstalacaoHeader>
          <Stepper style={{ width: '480px', margin: '0 auto' }}>
            <Step title='Identificar instalação' status={getStepStatus(0, step)} />
            <Step title='Cadastrar instalador' status={getStepStatus(1, step)} />
            <Step title='Finalizar instalação' status={getStepStatus(2, step)} />
          </Stepper>
        </InstalacaoHeader>

        <Paper style={{ backgroundColor: 'white', padding: '2rem 2rem 0 2rem' }}>{children}</Paper>
      </VFlow>
    </PageContent>
  )
}
